var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.595,
  height: 16.595,
  viewBox: "0 0 16.595 16.595"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-27 901.595)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.3,0a8.3,8.3,0,1,0,8.3,8.3A8.3,8.3,0,0,0,8.3,0Z",
  transform: "translate(27 -901.595)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.781.171,2.474,5.495,1.09,3.072a.583.583,0,1,0-1.013.579L1.841,6.738a.584.584,0,0,0,.507.295.578.578,0,0,0,.288-.076.609.609,0,0,0,.138-.109l.006-.006L8.606,1a.583.583,0,0,0,0-.825A.579.579,0,0,0,7.781.171Z",
  transform: "translate(30.907 -896.813)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/circle-check.fcfb2140.svg";
export { SvgComponent as ReactComponent };